module.exports = new __parcel__URL__("pagination.53955c73.jpg").toString();